import { forwardRef, useRef } from 'react';
import '../style/Hero.scss';
import { useScrollParallax } from '../hooks/useScrollTrigger';

const Hero = forwardRef(({ heroRef }) => {
    const background = useRef(null);

    // Background zoom effect on scroll
    useScrollParallax(background, {
        to: { scale: 1.8 },
        triggerRef: heroRef,
        start: 'top - 10% top',
        end: 'bottom + 15% top',
    });

  return (
    <div className='hero section' id='hero' ref={heroRef}>
        <div className='leftSide'>
            <h1 className='header'>Ty Allembert</h1>
            <h3 className='subHeader'>Web/Software Engineer</h3>
            <div className='skillsContainer'>
                <div className='skill html'>
                    <p>HTML</p>
                </div>
                <div className='skill css'>
                    <p>CSS</p>
                </div>
                <div className='skill javascript'>
                    <p>Javascript</p>
                </div>
                <div className='skill react'>
                    <p>React JS</p>
                </div>
                <div className='skill swiftui'>
                    <p>Next JS</p>
                </div>
                <div className='skill python'>
                    <p>Python</p>
                </div>
                <div className='skill flask'>
                    <p>SQL</p>
                </div>
            </div>
        </div>
        <div className='rightSide'>
            {/* <img className='ty' src="images/caricature.png" alt='Ty Allembert' /> */}
            <img ref={background} className='caricature caricatureBackground' src="images/caricature_background.png" alt='Ty Allembert' />
            <img className='caricature caricatureForeground' src="images/caricature_foreground.png" alt='Ty Allembert' />
        </div>
    </div>
  );
})

export default Hero;
